import { render, staticRenderFns } from "./badInspection.vue?vue&type=template&id=faaba0ae&scoped=true&"
import script from "./badInspection.vue?vue&type=script&lang=js&"
export * from "./badInspection.vue?vue&type=script&lang=js&"
import style0 from "./badInspection.vue?vue&type=style&index=0&id=faaba0ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faaba0ae",
  null
  
)

export default component.exports